// Sürücü Puantajı — istemci tarafı filtreler (localStorage + tarih aralığı metrikleri).

import { addDays, todayYMD, daysInRange } from "./utils";

export { daysInRange };

export const FILTER_STORAGE_KEY = "driverPerformance.filters";
export const RANGE_DAYS = 30;

export function defaultFilterState() {
  const rangeEnd = addDays(todayYMD(), -1);
  return {
    rangeEnd,
    rangeStart: addDays(rangeEnd, -(RANGE_DAYS - 1)),
    nameQuery: "",
    metricsMissingOnly: false,
    activeTab: "performance",
  };
}

/** Bitiş tarihine göre başlangıcı [end-29, end] aralığına sıkıştırır. */
export function clampDateRange(rangeStart, rangeEnd) {
  const minStart = addDays(rangeEnd, -(RANGE_DAYS - 1));
  let start = rangeStart;
  let end = rangeEnd;
  if (start < minStart) start = minStart;
  if (start > end) start = end;
  return { rangeStart: start, rangeEnd: end };
}

export function loadStoredFilters() {
  const defaults = defaultFilterState();
  try {
    const raw = localStorage.getItem(FILTER_STORAGE_KEY);
    if (!raw) return defaults;
    const parsed = JSON.parse(raw);
    const yesterday = addDays(todayYMD(), -1);
    let rangeEnd = parsed.rangeEnd || defaults.rangeEnd;
    if (rangeEnd > yesterday) rangeEnd = yesterday;
    let rangeStart = parsed.rangeStart || addDays(rangeEnd, -(RANGE_DAYS - 1));
    const clamped = clampDateRange(rangeStart, rangeEnd);
    const tab = parsed.activeTab;
    return {
      rangeEnd: clamped.rangeEnd,
      rangeStart: clamped.rangeStart,
      nameQuery: typeof parsed.nameQuery === "string" ? parsed.nameQuery : "",
      metricsMissingOnly: !!parsed.metricsMissingOnly,
      activeTab: tab === "upcoming" || tab === "rest" || tab === "performance" ? tab : "performance",
    };
  } catch {
    return defaults;
  }
}

export function saveStoredFilters(state) {
  try {
    localStorage.setItem(
      FILTER_STORAGE_KEY,
      JSON.stringify({
        rangeStart: state.rangeStart,
        rangeEnd: state.rangeEnd,
        nameQuery: state.nameQuery,
        metricsMissingOnly: state.metricsMissingOnly,
        activeTab: state.activeTab,
      }),
    );
  } catch {
    // localStorage dolu / devre dışı — sessizce geç
  }
}

function round1(n) {
  return Math.round((Number(n) || 0) * 10) / 10;
}

function sumDays(days) {
  return days.reduce(
    (acc, d) => ({
      count: acc.count + (d.count || 0),
      km: acc.km + (d.km || 0),
      minutes: acc.minutes + (d.minutes || 0),
    }),
    { count: 0, km: 0, minutes: 0 },
  );
}

/** dailySeries üzerinden seçili [rangeStart, rangeEnd] için tablo metriklerini üretir. */
export function computeMetricsForRange(dailySeries, rangeStart, rangeEnd) {
  const series = (dailySeries || []).filter((d) => d.date >= rangeStart && d.date <= rangeEnd);
  const period = sumDays(series);
  const lastDay = series.find((d) => d.date === rangeEnd) || { count: 0, km: 0, minutes: 0 };
  const weekStart = addDays(rangeEnd, -6);
  const weekDays = series.filter((d) => d.date >= weekStart && d.date <= rangeEnd);
  const week = sumDays(weekDays);
  return {
    day: { count: lastDay.count, km: lastDay.km, minutes: lastDay.minutes },
    week: { count: week.count, km: round1(week.km), minutes: week.minutes },
    month: { count: period.count, km: round1(period.km), minutes: period.minutes },
  };
}

/** API satırını seçili tarih aralığına göre görüntüleme satırına dönüştürür. */
export function mapRowToDateRange(row, rangeStart, rangeEnd) {
  const dailySeries = (row.dailySeries || []).filter((d) => d.date >= rangeStart && d.date <= rangeEnd);
  return {
    ...row,
    dailySeries,
    metrics: computeMetricsForRange(row.dailySeries, rangeStart, rangeEnd),
  };
}

/** Puantaj kayıtları satırları — isim arama + eksik metrik filtresi. */
export function filterWorklogRows(rows, { nameQuery, metricsMissingOnly }) {
  let out = rows;
  if (metricsMissingOnly) {
    out = out.filter((r) => r.metricsMissing);
  }
  const q = (nameQuery || "").trim().toLocaleLowerCase("tr");
  if (q) {
    out = out.filter((r) => (r.driverName || "").toLocaleLowerCase("tr").includes(q));
  }
  return out;
}

/** Paylaşılan isim/metrik filtrelerini kaydet (performans + puantaj kayıtları). */
export function saveSharedDriverFilters({ nameQuery, metricsMissingOnly }) {
  const existing = loadStoredFilters();
  saveStoredFilters({ ...existing, nameQuery, metricsMissingOnly });
}

/** İsim (içerir arama) + eksik metrik / yolcu yok filtresi. */
export function applyDriverFilters(rows, { nameQuery, metricsMissingOnly }) {
  let out = rows;
  if (metricsMissingOnly) {
    out = out.filter((r) => r.metricsMissing);
  }
  const q = (nameQuery || "").trim().toLocaleLowerCase("tr");
  if (q) {
    out = out.filter((r) => (r.driver.name || "").toLocaleLowerCase("tr").includes(q));
  }
  return out;
}
